import { useEffect, useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { api, fmtDate } from "@/lib/api";

const EVENTS = "email.delivered, email.delivery_delayed, email.bounced, email.complained, email.opened, email.clicked";

export function TrackingCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/tracking/status").then((r) => setS(r.data)); }, []);
  if (!s) return null;

  const copy = () => { navigator.clipboard.writeText(s.webhook_url); toast.success("Webhook URL copied"); };

  return (
    <div className="rounded-xl border border-border bg-card p-6 space-y-3" data-testid="tracking-card">
      <div className="flex items-center justify-between gap-2">
        <h3 className="font-display font-semibold">Delivery &amp; open tracking</h3>
        <span data-testid="tracking-status-pill" className={`text-[11px] font-mono px-2 py-0.5 rounded-full border ${s.configured ? "bg-emerald-500/10 text-emerald-700 border-emerald-500/20" : "bg-amber-500/10 text-amber-700 border-amber-500/20"}`}>
          {s.configured ? "Active" : "Not connected"}
        </span>
      </div>
      <p className="text-xs text-muted-foreground leading-relaxed">Shared by all five projects. In Resend → Webhooks, add this endpoint and select the events below.</p>
      <button onClick={copy} data-testid="tracking-webhook-copy" className="w-full text-left flex items-center gap-2 rounded-md border border-border bg-background px-3 py-2 hover:bg-secondary">
        <span className="font-mono text-[11px] truncate flex-1" data-testid="tracking-webhook-url">{s.webhook_url}</span><Copy className="h-3.5 w-3.5 shrink-0" />
      </button>
      <p className="text-[11px] font-mono text-muted-foreground leading-relaxed">{EVENTS}</p>
      <p className="text-xs text-muted-foreground">Also enable <strong>Open</strong> and <strong>Click tracking</strong> on your domain in Resend → Domains.</p>
      <p className="text-xs text-muted-foreground" data-testid="tracking-last-event">Last event received: {fmtDate(s.last_event_at)} · {s.events_received} events · {s.trackable_sends} emails sent via Resend</p>
      {s.last_failure && (
        <p className="text-xs text-rose-700" data-testid="tracking-last-failure">
          Last rejected event ({fmtDate(s.last_failure.at)}): {s.last_failure.reason}. Check that the signing secret matches the endpoint in Resend.
        </p>
      )}
      {s.configured && s.trackable_sends > 0 && !s.last_event_at && (
        <p className="text-xs text-amber-700" data-testid="tracking-no-events">No events received yet. Make sure the Resend webhook points to exactly the URL above.</p>
      )}
    </div>
  );
}
